/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RgbSlider from './RgbSlider';
import ColorConversion from 'utilities/ColorConversion';

export default class ColorSliders extends Component{

	static propTypes = {
		onColorChange: PropTypes.func,
		selectedColorType: PropTypes.string,
		color: PropTypes.string
	}

	static defaultProps = {
		color: '#FFFFFF',
		selectedColorType: 'RGB'
	}

	constructor(props){
		super(props);

		this.state = {
			hslColor: ColorConversion.convertRgbToHsl(props.color)
		};
	}

	componentDidUpdate(prevProps){
		if( this.props.color != prevProps.color ) {
			const newColor = this.props.color;
			// if the current HSL doesn't map to the RGB then we reset it
			if ( newColor != ColorConversion.convertRgbValToRgbHex(ColorConversion.convertHslToRgb(this.state.hslColor)) ) {
				this.setState({ hslColor: ColorConversion.convertRgbToHsl( newColor ) });
			}
		}
	}

	onRGBChange = ( value, color ) => {
		if ( isNaN(value) ) {
			return;
		}
		let rgbColor = ColorConversion.convertRgbHexToRgbVal(this.props.color);
		rgbColor[ color.toLowerCase() ] = parseInt( value );
		const rgbHex = ColorConversion.convertRgbValToRgbHex(rgbColor);
		if ( rgbHex != this.props.color ) {
			this.props.onColorChange(rgbHex, false);
		}
	}

	onHSLChange = ( value, color ) => {
		if ( isNaN(value) ) {
			return;
		}
		let hslColor = { ...this.state.hslColor };
		switch ( color ){
			case 'Hue':
				if ( Math.round(hslColor.hue) === value ) { return; }
				hslColor.hue = value;
				break;
			case 'Saturation':
				if ( Math.round(hslColor.sat * 100) === value ) { return; }
				hslColor.sat = value / 100;
				break;
			case 'Brightness':
				if ( Math.round(hslColor.light * 100) === value ) { return; }
				hslColor.light = value / 100;
				break;
		}
		this.setState( { hslColor: hslColor });
		const rgbHex = ColorConversion.convertRgbValToRgbHex( ColorConversion.convertHslToRgb(hslColor) ) ;
		if ( rgbHex != this.props.color ){
			this.props.onColorChange( rgbHex );
		}
	}

	_getSliders(){
		switch(this.props.selectedColorType){
			case 'RGB': {
				const rgbVal = ColorConversion.convertRgbHexToRgbVal(this.props.color);
				return(
					<div>
						<RgbSlider
							key={'red'}
							color={'Red'}
							onChange={this.onRGBChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={rgbVal.red}
						/>
						<RgbSlider
							key={'green'}
							color={'Green'}
							onChange={this.onRGBChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={rgbVal.green}
						/>
						<RgbSlider
							key={'blue'}
							color={'Blue'}
							onChange={this.onRGBChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={rgbVal.blue}
						/>
					</div>
				);
			}
			case 'HSB': {
				return(
					<div>
						<RgbSlider
							key={'hue'}
							color={'Hue'}
							onChange={this.onHSLChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={Math.round(this.state.hslColor.hue)}
						/>
						<RgbSlider
							key={'sat'}
							color={'Saturation'}
							onChange={this.onHSLChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={Math.round(this.state.hslColor.sat * 100)}
						/>
						<RgbSlider
							key={'light'}
							color={'Brightness'}
							onChange={this.onHSLChange.bind(this)}
							selectedColorType={this.props.selectedColorType}
							value={Math.round(this.state.hslColor.light * 100)}
						/>
					</div>
				);
			}
		}
	}

	render(){
		return(
			<div id='idRGBWrapper'>
				{this._getSliders()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/ColorSliders.js